// extracted by mini-css-extract-plugin
export default {"cls1":"Autocomplete-cls1__bfb1ebdcd13761af3f0f","cls2":"Autocomplete-cls2___9fbc022fff0575a45c7 Autocomplete-cls1__bfb1ebdcd13761af3f0f"};